import React, { Component } from "react";
import { Button } from "@americanexpress/dls-react";
import "./AccessApprovalStyle.css";
import { withTranslation } from "react-i18next";
import Header from "../Header/Header";
import one from "../../assets/Group 363.svg";
import two from "../../assets/progress 2.svg";
import three from "../../assets/Group 364.svg";
import Timer from "../Timer/Timer";
import AccessApprovalSection from "./AccessApprovalSection";
import { APPROVER_COUNT } from "../Common/constants";

class AccessApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      j: 0,
      newarr: [],
      validsubmit: false,
      emptyApproverDetails: false,
      count: 0,
      usersmain: [],
      minutes: 0,
      seconds: 0,
      i: 0,
      authindex: 0,
      userindex: 0,
      value: [],
      users: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        emailId: "",
        position: "",
        country: [],
      },
      auth: [],
      delcountry: "",
      submit: false,
      show: false,
      checked: false,
      checkarray: {},
      disable: {},
      country: {},
      next: false,
      notchecked: true,
      confirm: 0,
      success: false,
      open: false,
      accessCountries: [],
      disabled: false,
      view: true,
      disabledview: false,
      app: [],
      index: 0,
    };
  }

  componentDidMount() {
    if (this.props.location.state[5]) {
      this.setState({ newarr: this.props.location.state[5] });
    }
    if (this.props.location.state[6]) {
      this.setState({ newarr: this.props.location.state[6] });
    }

    let users = this.props.location.state[0];
    let value = this.state.value;
    let userData = users?.map((user, index) => {
      const desiredCount = APPROVER_COUNT[user?.country] || 1;
      const authorizedSignatories = (user?.authorizedSignatories || []).slice(0, desiredCount);
      const authorizedSignatoriesCount = (+user?.authorizedSignatoriesCount > desiredCount)
        ? `${desiredCount || 1}`
        : user?.authorizedSignatoriesCount || '1';
      while (authorizedSignatories.length < desiredCount) authorizedSignatories.push({});
      value[index] = 1;
      return { ...user, authorizedSignatories, authorizedSignatoriesCount };
    });
    this.setState({ value: value });
    this.setState({ usersmain: userData }, () => {
      if (this.props.history.location.state[3] === true) {
        if (this.props.history.location.state[4] === true) {
          this.setState({ i: this.props.history.location.state[0].length - 1 });
        } else {
          let i = 0;

          this.state.usersmain.map((user) => {
            if (user.authorizedSignatories.length > 0) {
              if (user.selfenroll === "1") {
                i = this.state.usersmain.indexOf(user);
              } else {
                let len = 0;
                let disable = {};
                if (
                  user.authorizedSignatories.map((con) => {
                    len += con.country.length;
                    if (len !== user.access.length) {
                      i = this.state.usersmain.indexOf(user);
                    } else {
                      i = this.state.usersmain.indexOf(user) + 1;
                    }
                    con.country.map((key) => (disable[key] = true));
                    return 0;
                  })
                )
                  this.setState({ disable, country: disable });
              }
            }
            return 0;
          });

          this.setState({ i }, () => {
            if (this.state.usersmain[this.state.i].selfenroll === "1") {
              let users = { ...this.state.users };
              users.firstName = this.state.usersmain[this.state.i].firstName;
              users.lastName = this.state.usersmain[this.state.i].lastName;
              users.emailId = this.state.usersmain[this.state.i].emailId;
              users.phoneNumber =
                this.state.usersmain[this.state.i].phoneNumber;
              this.setState({ users });
            }
          });
        }
      } else {
        /** This condition makes everytime TnC checkboxes value as false when you
         *  are going back to first page and coming to this page again  */
        // this.state.usersmain.map((user) => {
        //   if (user.selfenroll === "1") {
        //     for (var i = 0; i < user.authorizedSignatories.length; i++) {
        //       user.authorizedSignatories[i].agree = false;
        //     }
        //   }
        // });
        if (this.state.usersmain[0].selfenroll === "1") {
          let users = { ...this.state.users };

          users.firstName = this.state.usersmain[0].firstName;
          users.lastName = this.state.usersmain[0].lastName;
          users.emailId = this.state.usersmain[0].emailId;
          users.phoneNumber = this.state.usersmain[0].phoneNumber;

          this.setState({ users });
        }
      }
    });
    window.scrollTo(0, 0);
  }

  assignApprover = (index) => {
    this.setState({
      index: index,
      open: true,
      app: this.state.newarr[index],
      accessCountries: this.state.usersmain[index].access.map(
        (acc) => acc.country
      ),
    });
  };

  getUser = (user, i, id, disable) => {
    if (disable) {
      this.setState({ view: false });
    }
    const { usersmain } = this.state;
    if (usersmain[i]?.selfenroll === "2") {
      let con = [];
      usersmain[i].access.map((acc) => {
        con.push(acc.country);
      });
      user.country = con;
    }
    // if (usersmain[i].selfenroll === "1") {
    //   usersmain[i].authorizedSignatories[0] = user;
    // } else {
    //   usersmain[i].authorizedSignatories[id] = user;
    // }
    usersmain[i].authorizedSignatories[id] = user;

    this.setState({ usersmain });
  };

  gotoconfirm = () => {
    let self = "";
    let pa = "";
    let len;
    let usersLength = this.state.usersmain.length;
    this.setState({ submit: true });
    this.state.usersmain.map((user, index) => {
      let count = 0;
      let authorizedSignatoriesLength = 0;
      let authorizedSignatories = user.authorizedSignatories;
      user.authorizedSignatoriesCount = this.state.value[index];
      if (authorizedSignatories?.length > 0 && this.state.value[index] > 0) {
        authorizedSignatories = authorizedSignatories.slice(0, this.state.value[index]);
      }
      if (authorizedSignatories?.length === 0) {
        len = 0;
        this.setState({ disabled: true });
      } else {
        if (this.state.newarr.length === 0) {
          this.setState({ disabledview: true });
        } else {
          this.setState({ disabledview: false });
        }
        authorizedSignatories.map((obj) => {
          if (user.selfenroll === "1") {
            if (obj.agree === true) {
              authorizedSignatoriesLength += 1;
              if (authorizedSignatories.length === authorizedSignatoriesLength) {
                self = "yes";
              }
              this.setState({ disabled: false });
            } else {
              this.setState({ disabled: true });
              self = "no";
            }
          } else {
            if (obj.agree === true) {
              count = count + 1;
              this.setState({ disabled: false });
            } else {
              this.setState({ disabled: true });
            }
            if (count === authorizedSignatories.length) {
              pa = "yes";
              this.setState({ disabled: false });
            } else {
              this.setState({ disabled: true });
              pa = "no";
            }
          }
        });
      }

      if (self === "yes" || pa === "yes") {
        usersLength -= 1;
      }
    });
    if (pa !== "no" && self !== "no" && len !== 0 && usersLength === 0) {
      this.setState({ disabled: false });
      this.props.history.push("/confirmation", [
        this.state.usersmain,
        this.state.minutes,
        this.state.seconds,
        this.props.history.location.state[4],
        this.state.newarr,
        this.props.location.state[7],
        this.props.location.state[8],
        this.state.users.agreedCountries,
      ]);
    } else {
      this.setState({ disable: true });
    }
  };

  gotoBack = () => {
    const showCheckBox =
      this.props.history.location.state !== undefined
        ? this.props.history.location.state[6]
        : this.props.location.state[7];
    const modifyCheckBox =
      this.props.history.location.state !== undefined
        ? this.props.history.location.state[7]
        : this.props.location.state[8];
    localStorage.getItem("modify") === "true"
      ? this.props.history.push("/modify-user", [
          this.state.usersmain,
          this.state.minutes,
          this.state.seconds,
          "prev",
          this.state.newarr,
          showCheckBox,
          modifyCheckBox,
        ])
      : this.props.history.push("/new-user", [
          this.state.usersmain,
          this.state.minutes,
          this.state.seconds,
          "prev",
          this.state.newarr,
        ]);
  };

  getapprover = (arr, i) => {
    let newarr = [...this.state.newarr];
    newarr[i] = arr;
    this.setState({ newarr });
    this.setState({ open: false });
    this.setState({ disabledview: false });
    let usersmain = [...this.state.usersmain];
    if (this.state.value[i] < usersmain[i].authorizedSignatories.length) {
      usersmain[i].authorizedSignatories = usersmain[
        i
      ].authorizedSignatories.slice(0, parseInt(this.state.value[i]));
    }
    usersmain[i].authorizedSignatories.map((auth) => {
      let array = [];
      arr.map((obj) => {
        if (auth.firstName === obj.appr) {
          array.push(obj.con);
        }
        auth.country = array;
      });
    });
    this.setState({ usersmain });
  };

  setValue = (targetValue) => {
    this.setState({ value: targetValue });
  };

  render() {
    const { t } = this.props;
    const { submit, disabled, disabledview, view, open, usersmain } =
      this.state;

    return (
      <>
        <Header />
        <div className="accessApprovalHeader">
          <div className="headinga">
            <div className="step1">
              <div className="step-counter">
                <img src={one} className="stepimg" alt="step1" />{" "}
                <span className="active"> {t("newuser.userdetails")}</span>
              </div>
              <div className="step-counter">
                <img src={two} alt="step2" className="stepimg" />
                <span className="active">{t("access.approval")}</span>
              </div>
              <div className="step-counter">
                <img src={three} alt="step3" className="stepimg" />
                <span className="stepper">{t("confirm.confirmdetails")}</span>
              </div>
            </div>

            <div className="timer">
              <Timer time={"0"} hist={this.props.history} />
            </div>
          </div>
        </div>

        <AccessApprovalSection
          i18n={this.props.i18n}
          usersmain={usersmain}
          submit={submit}
          disabled={disabled}
          disabledview={disabledview}
          view={view}
          open={open}
          value={this.state.value}
          assignApprover={this.assignApprover}
          getUser={this.getUser}
          getapprover={this.getapprover}
          locationState={this.props.location.state}
          newarr={this.state.newarr}
          setValue={this.setValue}
          app={this.state.app}
          accessCountries={this.state.accessCountries}
        />

        {/* BACK AND CONTINUE BUTTON STARTS */}
        <div className="container buttonBlock">
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <div className="float-right">
                <div className="float-left">
                  <Button
                    styleType="secondary"
                    onClick={this.gotoBack}
                    className="backButton"
                  >
                    {t("access.returnUserDetails")}
                  </Button>
                </div>

                <div className="float-right">
                  <Button
                    styleType="primary"
                    onClick={this.gotoconfirm}
                    className="nextButton"
                  >
                    {t("access.proceedApprover")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* END OF BACK AND CONTINUE BUTTON */}

        <div className="bottomLine"></div>
      </>
    );
  }
}

export default withTranslation("common")(AccessApproval);
